import type React from 'react';

import { MoveDownRightIcon, MoveUpRightIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

export const TrendArrow: React.FC<{ changeValue?: number | null; color?: boolean }> = ({
  changeValue,
  color = true,
}) => {
  if (typeof changeValue !== 'number' || Number.isNaN(changeValue) || !Number.isFinite(changeValue))
    return null;

  return changeValue > 0 ? (
    <MoveUpRightIcon className={cn('h-4 w-4 print:h-2 print:w-2', color && 'text-primary-light')} />
  ) : changeValue < 0 ? (
    <MoveDownRightIcon className={cn('h-4 w-4 print:h-2 print:w-2', color && 'text-destructive')} />
  ) : null;
};
